<template>
    <v-row>
      <div class="col-md-12 home-box">
        <Breadcrumbs :title="'Branches'"></Breadcrumbs>
        <BranchListTable></BranchListTable>
      </div>
      <div class="col-md-12 home-tabs-body">
      </div>
    </v-row>
  </template>
<script>
import BranchListTable from "@/components/branches/BranchListTable.vue";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default { components: { BranchListTable,
      Breadcrumbs } };
</script>
